<template>
  <nav class="navbar navbar-inverse navbar-expand-md fixed-top bg-white">
    <div class="container px-0">
      <a class="navbar-brand" href="https://www.jskids.ro">
        <img src="./../assets/images/logo/jskids-logo.png" height="30" alt="logo jskids" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav3"
        aria-controls="navbarNav3"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span>
          <svg
            class="svg-inline--fa fa-bars fa-w-14"
            aria-hidden="true"
            data-prefix="fas"
            data-icon="bars"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            data-fa-i2svg
          >
            <path
              fill="currentColor"
              d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
            />
          </svg>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav3">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link to="/home" class="nav-link">{{ $t("nav.homeBtn") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">{{ $t("nav.aboutBtn") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/courses" class="nav-link">{{ $t("nav.kidsCoursesBtn") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/private-schools" class="nav-link">{{ $t("nav.privateSchoolsBtn") }}</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/teachers" class="nav-link">{{ $t("nav.teachersBtn") }}</router-link>
          </li>
          <li class="nav-item">
            <a href="#footer" class="nav-link">{{ $t("nav.contactBtn") }}</a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link to="/register" class="nav-link bold-underlined">{{ $t("nav.registerBtn") }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "menu",
};
</script>
